/**
 * Module for sDialog
 * @module services/sDialog/component
 * @preferred
 */

import singletons from "@/services/singletons";
import Component from "vue-class-component";
import SDialogRef from "@/services/sDialog/classes/SDialogRef";
import Vue, { VueConstructor } from "vue";
import _ from "lodash";
import {
  ISDialogOptions,
  ISDialogOptionsInternal
} from "@/services/sDialog/classes/interfaces";

@Component
export default class sDialogComponent extends Vue {
  dialogs: Array<ISDialogOptionsInternal> = [];

  $refs: {
    [key: string]: any;
  };

  constructor() {
    super();
    this.$refs = {} as any;
  }

  private mounted() {
    singletons.sDialog = this;

    window.addEventListener("popstate", event => {
      if (this.dialogs.length) _.last(this.dialogs)!.dialogRef!.close();
    });
  }

  /**
   * Function to open a component in Dialog.
   *
   * @author Pranav Jindal
   * @param {ISDialogOptions} opts Options for dialog
   * @returns A dialog reference to control opened dialog.
   * @memberof sDialogCtrl
   */
  open(opts: ISDialogOptions & { component: VueConstructor }) {
    opts.fullWidth = opts?opts.fullWidth:false;
    opts.fullscreen = opts?opts.fullscreen:false;
    opts.persistent = opts?opts.persistent:true;
    opts.width = opts?opts.width:'auto';
    opts.maxWidth =opts?opts.maxWidth: '50%';
    // opts.keepAlive = _.propOrDefault(opts, "keepAlive", false);
    if (this.$vuetify.breakpoint.smAndDown) opts.maxWidth = "95%";

    const array = new Uint32Array(1);
    window.crypto.getRandomValues(array);
    let id = array[0].toString(36).slice(2);

    let finalOptions: ISDialogOptionsInternal = {
      id,
      compId: `comp${id}`,
      active: false,
      ...opts
    };
    this.dialogs.push(finalOptions);

    window.history.pushState({}, id);

    return new SDialogRef(id, finalOptions);
  }
}
